import React from 'react'
import { array, string } from 'prop-types'
import SuperAgent from 'superagent'
import legacyIESupport from 'superagent-legacyiesupport'

class JsonStorage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      data: {}
    }
  }

  componentDidMount() {
    const { functionParams } = this.props
    if (functionParams.length !== 2) return
    SuperAgent
      .post('https://seo-rpc-gateway.dock-yard.io/json-storage')
      .use(legacyIESupport)
      .send({ func: 'fetch', data: { 'group': functionParams[0], 'variable': functionParams[1] } })
      .end((err, res) => {
        if (err || !res || !res.body) return
        this.setState({ data: res.body })
      });
  }

  render () {
    const { id } = this.props
    const { data: { value = '' } } = this.state
    return (
      <span id={id}>{value}</span>
    )
  }

}

JsonStorage.propTypes = {
  id: string.isRequired,
  functionParams: array.isRequired
}

export default JsonStorage



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/json-storage.jsx